import { updateElement } from 'store/entities/updateElement/updateElementThunk';
export default updateElement;
